import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { instance } from "../../../../Actions/AxiosInstance";
import { RightDrawer } from "../../../../Actions/commonAction";
import { updateSubscriptionInfo } from "../../../../Actions/SubscriptionInfo";
import defaultEmp from "../../../../Assets/Images/defaultEmp.svg";
import payrollglyph from "../../../../Assets/Svg/payroll-glyph-16-px.svg";
import jupiterland from "../../../../Assets/Svg/jupiterland.svg";
import temple from "../../../../Assets/Images/temple.svg";
import IOS from "../../../../Assets/Images/ios.svg";
import Play from "../../../../Assets/Images/play.svg";
import ScanJupiter from "../../../../Assets/Images/scanjupiter.svg";
import Link2 from "../../../../Assets/Images/link2.svg";
import Step2 from "../../../../Assets/Images/step2.svg";
import Step3_1 from "../../../../Assets/Images/step3-1.svg";
import Step3_2 from "../../../../Assets/Images/step3-2.svg";
import Step3_3 from "../../../../Assets/Images/step3-3.svg";
import Step3_4 from "../../../../Assets/Images/step3-4.svg";
import CS from "../../../../Assets/Images/customer-support.svg";
import createstore from "../../../../store";
import { getFormattedImageLink } from "../../../../Utils";
import Chip from "@material-ui/core/Chip";
import If from "../../../../Component/Common/If"; 
import Button from "@material-ui/core/Button";
import get from "lodash/get";
import {
  profilePrivacyInfo,
  CheckActionPermission,
} from "../../../../Actions/commonAction";

import EmpBankingFormDrawer from "./EmpBankingFormDrawer";
import CreateComp from "../create";
import { NoRecordFound } from "./NoRecordFound";
import addressEmployee from "../../../../Assets/Images/banking-details.svg";
import Drawer from "@material-ui/core/Drawer";
import Typography from "@material-ui/core/Typography";
import { Card, withWidth } from "@material-ui/core";
import { fontFamily } from "@mui/system";
import { track } from '@amplitude/analytics-browser';
import WarningSign from "../../../../Assets/Images/warning-sign.svg";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  padding40: {
    padding: 0,
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(45deg)",
  },
});

class JupiterMandate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 10,
      managerlimit: 3,
      ManagerList: [],
      EmpList: [],
      DepList: [],
      list: [],
      TeamEmpList: [],
      colleagueid: "",
      // Emplist: [],
      OpenFlag: false,
      fullcount: "",
      managerfullcount: "",
      teamfullcount: "",
      employeeid: "",
      allBankingDetails: [],
      hideButton: false,
      openOptions: false,
      openDrawer: false,
    };
    this.selectedElement = React.createRef();
    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  componentDidMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    let employeeid;

    const { AuthenticationAction } = createstore.getState();
    employeeid = AuthenticationAction.login.employeeid;
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;
    const { ismandate } = this.props;

    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const [isTrue, permissions] = CheckActionPermission("profile");
    let hideButton;
    permissions.editable
    ? colleagueid && colleagueid != employeeid
      ? masterprofileid != 9
        ? (hideButton = true)
        : (hideButton = false)
      : (hideButton = false)
    : masterprofileid != 9 ? (hideButton = true) : (hideButton = false);
    this.setState(
      {
        SubscriptionInfo,
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
        ismandate
      },
      () => {
        // this.GetManagerList();
        // this.GetEmpList();
        // this.GetDepList();
        this.GetAllBankingDetails();
      },
    );
  }

  toggleDrawer(value) {
    this.setState({ openDrawer: value });
    track("add-new-bank-clicked");
  }

  GetAllBankingDetails() {
    const URL = "employee/getempallbankdetail";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        if (result.data.result.length == 0) {
          this.setState({ flag: 0, dataReceived: true });
        } else {
          this.setState({
            allBankingDetails: result.data.result.filter((x) => x.isdefault == true),
            flag: 3,
            dataReceived: true,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPerticularBankingDetails(value, data) {
    const BankingDetails = data;
    const flag = value;
    this.setState({ BankingDetails, flag });
    this.toggleDrawer(true);
  }
 
  HelperSliderFlag(flag, text) {
    // this.setState({ HelperSlider: flag })
    let OpenFlag = "";
    if (flag == true) {
      OpenFlag = true;
      this.setState({ OpenFlag });
    } else {
      OpenFlag = false;
      this.setState({ OpenFlag });
    }
    if (text == "Profilemanager") {
      this.props.RightDrawer({
        drawerdata: text,
        open: "right",
        side: flag,
        empid: this.state.employeeid,
      });
    } else {
      this.props.RightDrawer({ drawerdata: text, open: "right", side: flag });
    }
  }

  GetManagerList() {
    const id = this.state.colleagueid
      ? this.state.colleagueid
      : this.state.employeeid;
    instance
      .get(
        `/subscription/getempolyeemanager/${id}/${3}/${this.state.offset}/${
          this.state.managerlimit
        }`,
      )
      .then((result) => {
        let ManagerList = [];
        result.data.result.length > 0
          ? (ManagerList = result.data.result)
          : (ManagerList = []);
        const managerfullcount =
          result.data.result.length > 0 ? result.data.result[0].totalcount : 0;
        this.setState({ ManagerList, managerfullcount });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetEmpList() {
    const URL = "/employee/getempteamemployee";
    const data = {
      limit: 7,
      offset: 0,
      isteamemployee: true,
    };
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        // data = {
        //     "employeeid": this.state.colleagueid
        // }
        // Object.assign(data, { employeeid: this.state.colleagueid });
        data.employeeid = this.state.colleagueid;
      } else {
        // data = {}
      }
    } else {
      // data = {
      //     "accountid": this.state.accountid,
      //     "subscriptionid": this.state.subscriptionid,
      //     "timezoneid": this.state.countrytimezoneid,
      //     "employeeid": this.state.employeeid,

      // }
      // Object.assign(data, {
      //   accountid: this.state.accountid,
      //   subscriptionid: this.state.subscriptionid,
      //   timezoneid: this.state.countrytimezoneid,
      //   employeeid: this.state.employeeid,
      // });
      data.accountid = this.state.accountid;
      data.subscriptionid = this.state.subscriptionid;
      data.timezoneid = this.state.countrytimezoneid;
      data.employeeid = this.state.employeeid;
    }
    instance
      .post(URL, data)
      .then((result) => {
        let EmpList = [];
        result.data.result.length > 0
          ? (EmpList = result.data.result)
          : (EmpList = []);
        const teamfullcount =
          result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
        this.setState({ EmpList, teamfullcount });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetDepList() {
    const URL = "/employee/getempteamemployee";
    const data = {
      limit: 7,
      offset: 0,
      isteamemployee: false,
    };
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        // data = {
        //     "employeeid": this.state.colleagueid
        // }
        data.employeeid = this.state.colleagueid;
      } else {
        // data = {}
      }
    } else {
      // data = {
      //     "accountid": this.state.accountid,
      //     "subscriptionid": this.state.subscriptionid,
      //     "timezoneid": this.state.countrytimezoneid,
      //     "employeeid": this.state.employeeid,

      // }
      // Object.assign(data, {
      data.accountid = this.state.accountid;
      data.subscriptionid = this.state.subscriptionid;
      data.timezoneid = this.state.countrytimezoneid;
      data.employeeid = this.state.employeeid;
      // });
    }
    console.log("data: ", data);
    instance
      .post(URL, data)
      .then((result) => {
        let EmpList = [];
        result.data.result.length > 0
          ? (EmpList = result.data.result)
          : (EmpList = []);
        const fullcount =
          result.data.result.length > 0 ? result.data.result[0].fullcount : 0;
        this.setState({ DepList: EmpList, fullcount });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getCount = (count) => {
    if (count >= 7) {
      return count - 7;
    }
    return 0;
  };

  getCountManager = (count) => {
    if (count >= 3) {
      return count - 3;
    }
    return 0;
  };

  SetFlag(value, success) {
    const flag = value;
    const successFlag = success;
    this.setState({ flag, BankingDetails: {}, successFlag }, () => {
      if (flag != 1) this.GetAllBankingDetails();
      this.props.UpdateStrength(true);
    });
  }

  SetColleagueInfo(colleagueInfo, e) {
    // if (this.state.colleagueid){
    //     this.props.history.push(`./${colleagueInfo.employeeid}`);
    // }else {
    // this.props.history.push(`./profile/${colleagueInfo.employeeid}`);
    // }
    // let result = {
    //     'data' : {'result': []}
    // }
    // colleagueInfo.employeeid
    // let colleagueid = this.state.SubscriptionInfo.SubscriptionData['colleagueid'] = colleagueInfo.employeeid
    // let info = this.state.SubscriptionInfo.SubscriptionData
    // result.data.result[0] = Object.assign(colleagueid, info);
    // result;
    // this.props.updateSubscriptionInfo(ReducersTypes.SUBSCRIPTIONINFO + '_FULFILLED', result)
    // window.open("https://www.youraddress.com","_self")
  }

  DeleteEmpBankingDetails = (item) => {
    const URL = `employee/deleteempbankdetail/${item.employeebankid}`;
    instance
      .delete(URL)
      .then(() => {
        this.GetAllBankingDetails();
        this.props.closeSnackbar();
        this.setState({flag:0 });
      })
      .catch((error) => {
        this.props.closeSnackbar();
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  };

  Deleteconfirmation = (item) => {
    this.props.enqueueSnackbar(`Are you sure you want to delete?`, {
      variant: "warning",
      action: [
        <Button
          variant="outlined"
          color="inherit"
          className="margin-right-16"
          size="small"
          onClick={() => this.DeleteEmpBankingDetails(item)}
        >
          Delete
        </Button>,
        <Button color="inherit" size="small"
          onClick={() => this.props.closeSnackbar()}>
          Cancel
        </Button>,
      ],
    });
  };

  render() {
    let model;
    const { flag ,openOptions, openDrawer} = this.state;
    const { hideButton } = this.state;
    const { classes } = this.props;

    return (
      <div>
        <Grid container spacing={2}>
          
        <Grid item xs={12} md={12} sm={12} >
          <Paper 
          
          style={{
            position: "relative",
            height: "684px",
            fontWeight: "700",
            lineHeight: "24px",
            padding:"24px",
            //width:"100%",
             }}>

                <div style={{
                background: "#FEF1D9",
                display: "flex",
                flexdirection: "row",
                width: "1000px",
                alignitems: "center",
                padding: "12px 24px",
                gap: "8px",
                position: "absolute",
                left: "0px",
                top: '0px',

            }}>
                  <img style={{ alignitems: "center",width:"16px",height:"15px" ,paddingRight:"8px"}} src={WarningSign} /> 
                  <span style={{  alignitems: "center",fontWeight: "700",fontSize: "14px",lineHeight: "20px", color: "#FAA500",fontstyle: "normal",fontfamily: "Mulish" }}>Attention required!</span>
              </div>
             
              
            <div style={{
                marginTop:"40px",
            }} >
            <FormattedMessage id="LbBanking" defaultMessage="Banking" />
            </div>
            
            <div style={{
                display:"flex",
            }} >
                <Grid item xs={12} md={9} sm={9} >
                    <div 
                    style={{
                        fontFamily: 'Muli", sans-serif !important',
                        fontStyle: "normal",
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "24px",
                        width:"70%",
                        paddingTop:"24px"
                        }}
                    >
                        As per our company policy salary will be disbursed to employee’s Jupiter Account (powered by Federal Bank), 
                        please add your Jupiter account details.
                    </div>
                    <div>
                    <span onClick={() => this.toggleDrawer(true)} className="btn btn-primary-md-blue"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "12px",
                        width: "182px",
                        marginTop:"24px",
                        borderRadius: "4px"
                    }}  >
                    <img  src={temple} />
                    Add bank account
                    </span>
                    </div>
                </Grid>
                <Grid item xs={12} md={3} sm={3} >
                    <div >
                    <img
                     style={{ width:"144px",height:"144px"}}
                    src={jupiterland}
                    //className="profile-img2"
                    />
                    </div>
                </Grid> 
            </div>
            <div style={{
                    //display:"flex", 
                   paddingTop:"24px ",
                }}>
                <FormattedMessage id="LbBanking" defaultMessage="How open Jupiter account?" />
                <div style={{display:"flex",paddingTop:"16px",}} >
                    <Grid item xs={12} md={4} sm={4} style={{marginRight:"16px"}}>
                        <div onClick={()=>{track("profile-step1-clicked")}} style={{ background: "#F3F1F9",borderRadius: "4px", padding:"12px 8px 12px 12px", width: "95%",height: "296px"}}>
                            <div style={{ fontWeight: "700",fontSize: "12px",lineHeight: "16px", color: "#6648AD"}}>Step 1</div>
                            <div style={{ fontWeight: "400",fontSize: "14px",lineHeight: "20px", paddingTop:"8px"}}>Scan QR to Install “Jupiter: Digital Bank Account”</div>
                            <div style={{ fontWeight: "700",fontSize: "12px",lineHeight: "16px", color: "#6648AD",  display: "flex",paddingTop:"16px"}}>Why Jupiter? 
                            <a href="https://jupiter.money/pro-salary-account" target="_blank"> <img style={{ height:"9px", width:"9px", marginTop:"2px", marginLeft:"8px"}} src={Link2} onClick={() => {track("why-jupiter-link-clicked")}} /> </a>
                            </div>
                            <div style={{paddingTop:"16px"}}>
                                <img style={{ paddingRight: "13px", height: "20px",width:" 67.5px"}} src={Play}/>
                                <img style={{height: "20px",width:" 67.5px"}} src={IOS}/>
                            </div>
                            <span 
                                style={{ display: "flex", marginTop:"12.75px", borderRadius: "4px", marginBottom:"12px" }} 
                            >
                                <img style={{ height: "136px", width: "136px"}} src={ScanJupiter} />
                                
                            </span>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={4} sm={4} style={{marginRight:"16px"}}>
                        <div onClick={()=>{track("profile-step2-clicked")}} style={{ background: "#F3F1F9",borderRadius: "4px", padding:"12px 8px 12px 12px", width: "95%",height: "296px"}}>
                            <div  style={{ fontWeight: "700",fontSize: "12px",lineHeight: "16px", color: "#6648AD"}}>Step 2</div>
                            <div style={{ fontWeight: "400",fontSize: "14px",lineHeight: "20px", paddingTop:"8px"}}>Use your phone number that is linked to your Aadhar card.</div>
                            <div style={{paddingTop:"24px"}}>
                                <img style={{ height:"180px", width:"180px", paddingLeft:"53px"}} src={Step2} /> 
                            </div>
                    </div>
                    </Grid> 
                    <Grid item xs={12} md={4} sm={4} style={{marginRight:"16px"}}>
                        <div onClick={()=>{track("profile-step3-clicked")}} style={{ background: "#F3F1F9",borderRadius: "4px", padding:"12px 16px 12px 12px", width: "95%",height: "296px"}}>
                            <div style={{ fontWeight: "700",fontSize: "12px",lineHeight: "16px", color: "#6648AD"}}>Step 3</div>
                            <div style={{ fontWeight: "400",fontSize: "14px",lineHeight: "20px", paddingTop:"8px"}}>Add your Jupiter bank account and get all the salary account benefits like:</div>
                            <div style={{ }}>
                                <img style={{ height:"28", width:"188", paddingTop:"10px"}} src={Step3_1} /> 
                                <img style={{ height:"28", width:"188", paddingTop:"10px"}} src={Step3_2} /> 
                                <img style={{ height:"28", width:"188", paddingTop:"10px"}} src={Step3_3} /> 
                                <img style={{ height:"28", width:"188", paddingTop:"10px"}} src={Step3_4} /> 
                            </div>
                        </div>
                    </Grid> 
                </div>
                <div style={{marginTop:"16px", height:"56", width:"755",  background: "#F3F1F9",borderRadius: "4px"}} >
                    <div style={{display:"flex", fontWeight: "400",fontSize: "14px",lineHeight: "20px",padding:"18px",}}>
                        <img style={{ height:"10", width:"10", paddingRight:"17px"}}
                            src={CS}
                        />
                        For any queries or help with the process please contact the HR Department.
                    </div>
                </div>
            </div>
          </Paper>
          </Grid>
          <div className="position-rel" >{model}</div>
              <Drawer
                anchor="right"
                open={openDrawer}
                onClose={() => this.toggleDrawer(false)}
                classes={{
                  paper: classNames(classes.drawerPaper),
                }}
              >
                {openDrawer && (
                  <EmpBankingFormDrawer
                  SetFlag={this.SetFlag.bind(this)}
                  data={this.state.BankingDetails}
                  colleagueid={this.state.colleagueid}
                  {...this.props}
                  toggleDrawer={this.toggleDrawer} 
                />
                )}
              </Drawer>
        </Grid>
      </div>
    );
  }
}

JupiterMandate.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateSubscriptionInfo: (type, payload) =>
        updateSubscriptionInfo(type, payload),
      RightDrawer: (data) => RightDrawer(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(JupiterMandate)));
